import React from 'react';
import HeaderEditorWithRealPreview from './HeaderEditorWithRealPreview';

const HeaderEditor: React.FC = () => {
  return <HeaderEditorWithRealPreview />;
};

export default HeaderEditor;
